module.exports = __webpack_public_path__ + "398d950b323ecd74c9def75ad3899fc4.png";